export default __webpack_public_path__ + "static/media/Banners_mespatrio_gmm_330x330.c231c81e.webp";